import * as React from "react";
import classnames from "classnames";
import { ButtonBase, ButtonBaseProps } from "@mui/material";
import "./CDButton.scss";

export type CDButtonColor =
  | "Primary Blue"
  | "Secondary/Text Regular"
  | "Danger (Text)";

const colorMap: Record<CDButtonColor, string> = {
  "Primary Blue": "button-color-blue",
  "Secondary/Text Regular": "button-color-grey",
  "Danger (Text)": "button-color-red",
};

export type CDButtonVariant = "Primary" | "Secondary" | "Tertiary";

const variantMap: Record<CDButtonVariant, string> = {
  Primary: "button-variant-primary",
  Secondary: "button-variant-secondary",
  Tertiary: "button-variant-tertiary",
};

export interface CDButtonProps extends Omit<ButtonBaseProps, "ref" | "color"> {
  buttonRef?: React.Ref<HTMLButtonElement>;
  color?: CDButtonColor;
  variant?: CDButtonVariant;
}

export function CDButton(props: CDButtonProps) {
  const { buttonRef, ...buttonProps } = props;

  const color = props.color || "Primary Blue";
  const variant = props.variant || "Primary";

  const classNames = classnames([
    "btn",
    colorMap[color],
    variantMap[variant],
    "cdata-button",
    props.className,
  ]);

  return (
    <ButtonBase {...buttonProps} className={classNames} ref={buttonRef}>
      {props.children}
    </ButtonBase>
  );
}
